import completeProfileImage1 from "assets/images/png/card-image1.png";
import completeProfileImage2 from "assets/images/png/card-image2.png";
import completeProfileImage3 from "assets/images/png/card-image3.png";

export const completeProfileList = [
  {
    key: "basic",
    image: completeProfileImage1,
    content:
      "Add your basic details like name, age, gender, and marital status to help others know you better.",
    btnText: "add basic details",
    href: "/my-profile#about-me",
  },
  {
    key: "career",
    image: completeProfileImage2,
    content:
      "Share your profession, income, and career background to improve compatibility with potential matches.",
    btnText: "add career details",
    href: "/my-profile#career",
  },
  {
    key: "contact",
    image: completeProfileImage3,
    content:
      "Update your contact information so interested matches can connect with you easily and securely.",
    btnText: "add contact details",
    href: "/my-profile#contact",
  },
  {
    key: "current_address",
    image: completeProfileImage1,
    content:
      "Provide your current living address to improve local match suggestions and transparency.",
    btnText: "add current address",
    href: "/my-profile#current-address",
  },
  {
    key: "family",
    image: completeProfileImage2,
    content:
      "Let others know about your family background and values — a key part of matchmaking decisions.",
    btnText: "add family details",
    href: "/my-profile#family",
  },
  {
    key: "interest",
    image: completeProfileImage3,
    content:
      "List your hobbies and interests to help others connect with your personality and lifestyle.",
    btnText: "add interest",
    href: "/my-profile#interests-personality",
  },
  {
    key: "permanent_address",
    image: completeProfileImage1,
    content:
      "Add your permanent address details to complete your location preferences and identity verification.",
    btnText: "add permanent address",
    href: "/my-profile#permanent-address",
  },
  {
    key: "personality",
    image: completeProfileImage2,
    content:
      "Describe your personality traits, lifestyle habits, and values to better align with like-minded people.",
    btnText: "add personality",
    href: "/my-profile#interests-personality",
  },
  {
    key: "physical_appearance",
    image: completeProfileImage3,
    content:
      "Add your physical details like height, body type, and complexion to complete your profile.",
    btnText: "add physical appearance",
    href: "/my-profile#physical",
  },
  {
    key: "verification",
    image: completeProfileImage1,
    content:
      "Account verification helps build trust and ensures a secure matchmaking experience.",
    btnText: "Verify your account",
    href: "/verification",
  },
  {
    key: "images",
    image: completeProfileImage2,
    content:
      "Add clear, recent photos to make your profile more appealing and build trust with matches.",
    btnText: "add profile image",
    href: "/my-profile",
  },
  {
    key: "partner_preference",
    image: completeProfileImage3,
    content:
      "Set your partner preferences to find matches who truly fit your expectations.",
    btnText: "add partner preference",
    href: "/my-profile#partner-preferences",
  },
];
